import PropTypes from 'prop-types';
import React from 'react';
import Link from 'next/link';
import { useFormatter } from 'next-intl';
import { connect } from 'react-redux';

import { isPeriod } from '../../../helper';

import { LongArrowRight, ArrowLeft } from '../../icons/arrow/arrow';
import EventDate from '../event-date/eventDate';
import Headline from '../../atoms/headline/headline';
import StyledTiltedTeaser from './tiltedTeaser.style';
import FilterTags from '../../atoms/filter-tags/filterTags';

const TiltedTeaser = props => {
  const { teaserPosition = 1, pageTags, headline, startDate, endDate, uri, banner } = props;

  const format = useFormatter();

  const hasTeaser = uri && headline;

  const isEvent = startDate && endDate;
  const period = startDate && endDate && isPeriod(startDate, endDate);
  const hasTime =
    startDate && endDate ? startDate.H && startDate.i && endDate.H && endDate.i : null;

  return (
    <StyledTiltedTeaser
      event={isEvent}
      teaserPosition={teaserPosition}
      hasTeaser={hasTeaser}
      {...props}
    >
      {banner && (
        <a className="tiltedTeaser__banner-link" tabIndex={0} href={banner.href}>
          {banner.href && (
            <div className="tiltedTeaser__banner-arrow">
              <ArrowLeft />
            </div>
          )}
          <span>{banner.message}</span>
        </a>
      )}
      <div className="tiltedTeaser__wrapper">
        <div className="tiltedTeaser__content-wrapper">
          {hasTeaser && (
            <Link
              href={{ pathname: `/universal`, query: { uri } }}
              as={uri}
              className="tiltedTeaser__link"
            >
              {isEvent && (
                <EventDate
                  className="tiltedTeaser__event"
                  period={period}
                  startDate={startDate}
                  endDate={endDate}
                  isTeaser
                />
              )}
              <div className="tiltedTeaser__content">
                {pageTags && pageTags.length > 0 && (
                  <FilterTags tags={pageTags} border className="tiltedTeaser__categories" />
                )}
                {hasTime && (
                  <time className="tiltedTeaser__time">
                    {format.dateTime(new Date(startDate.c), { hour: 'numeric', minute: 'numeric' })}
                    {' – '}
                    {format.dateTime(new Date(endDate.c), { hour: 'numeric', minute: 'numeric' })}
                  </time>
                )}
                <Headline teaser className="tiltedTeaser__headline">
                  {headline}
                </Headline>
                {!isEvent && (
                  <div className="tiltedTeaser__arrow">
                    <LongArrowRight />
                  </div>
                )}
              </div>
            </Link>
          )}
        </div>
      </div>
    </StyledTiltedTeaser>
  );
};

TiltedTeaser.propTypes = {
  currentTheme: PropTypes.string.isRequired,
  teaserPosition: PropTypes.number,
  banner: PropTypes.shape({
    href: PropTypes.string,
    message: PropTypes.string.isRequired
  }),
  pageTags: PropTypes.arrayOf(PropTypes.shape()),
  headline: PropTypes.string.isRequired,
  uri: PropTypes.string.isRequired,
  startDate: PropTypes.shape({
    d: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    m: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    y: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    H: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    i: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    c: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  endDate: PropTypes.shape({
    d: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    m: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    y: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    H: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    i: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    c: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })
};

export default connect(null, null)(TiltedTeaser);
